import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-1.png";
import { FaWhatsapp, FaBars, FaTimes } from "react-icons/fa";

const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center py-1">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Bharat Tour" className="h-[70px] w-auto p-1" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-10">
            <Link to="/" className="text-gray-900 font-medium hover:text-pink-600 transition">
              Home
            </Link>
            <Link to="/about" className="text-gray-900 font-medium hover:text-pink-600 transition">
              About
            </Link>
            <Link to="/packages" className="text-gray-900 font-medium hover:text-pink-600 transition">
              Tour Packages
            </Link>
             <Link to="/taxi-service" className="text-gray-900 font-medium hover:text-pink-600 transition">
              Taxi Service
            </Link>
            <Link to="/contact" className="text-gray-900 font-medium hover:text-pink-600 transition">
              Contact
            </Link>
          </div>

          {/* WhatsApp Button (Desktop) */}
          <div className="hidden md:flex">
            <a
              href="https://wa.me/9311051597"
              target="_blank"
              rel="noopener noreferrer"
              className="flex bg-pink-600 rounded-full items-center space-x-2 py-2 px-4 text-white hover:bg-pink-500 transition"
            >
              <FaWhatsapp className="text-xl" />
              <span>Connect</span>
            </a>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            className="md:hidden text-gray-900 text-2xl"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden flex flex-col bg-white absolute top-[100%] left-0 w-full shadow-lg transition-transform duration-300 ${isMobileMenuOpen ? "translate-y-0" : "-translate-y-[200%]"
            }`}
        >
          <Link
            to="/"
            className="py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about"
            className="py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/packages"
            className="py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Tour Packages
          </Link>
          <Link
            to="/contact"
            className="py-3 px-6 text-gray-900 font-medium hover:text-pink-600 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact
          </Link>
          <a
            href="https://wa.me/9311051597"
            target="_blank"
            rel="noopener noreferrer"
            className="flex bg-pink-600 mx-6 mt-3 rounded-full items-center space-x-2 py-2 px-4 text-white hover:bg-pink-500 transition"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaWhatsapp className="text-xl" />
            <span>Connect</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
